import { getToken } from '../utils/getToken'

export default {
  get,
  getCaseAppointments,
  getAll,
  getFiles,
  create,
  update,
  deleteAppointment,
}

async function handleSuccess(result) {
  if (!result.ok) {
    const errorText = await result.text().catch(() => 'No response body')

    if (result.status === 403) {
      throw new Error(`Access forbidden to this case (403). Response: ${errorText}`)
    }
    throw new Error(`HTTP ${result.status}: ${result.statusText}. Response: ${errorText}`)
  }
  return result.json()
}

function handleFailure(defaultErrorMessage, err) {
  const msg = err.message || err.toString()
  throw new Error(`${defaultErrorMessage} Details: ${msg}`)
}

function getFiles(caseNumber, appointmentNumber) {
  return fetch(`/api/cases/${caseNumber}/appointments/${appointmentNumber}/files`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      Accept: 'application/json',
    },
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to retrieve the list of requested files.', err))
}

function get(caseNumber, appointmentNumber) {
  return fetch(`/api/cases/${caseNumber}/appointments/${appointmentNumber}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to retrieve the list of appointments.', err))
}

function getCaseAppointments(caseNumber, filter) {
  let url = `/api/cases/${caseNumber}/appointments`

  if (filter) {
    url += `?$filter="${encodeURIComponent(filter)}"`
  }

  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to retrieve the list of appointments.', err))
}

function getAll(incompleteOnly = false) {
  return fetch(`/api/appointments?incompleteOnly=${incompleteOnly}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to retrieve the list of appointments.', err))
}

function create(caseNumber, model) {
  return fetch(`/api/cases/${caseNumber}/appointments`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(model),
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to create appointment.', err))
}

function update(caseNumber, appointmentNumber, model) {
  return fetch(`/api/cases/${caseNumber}/appointments/${appointmentNumber}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(model),
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to update appointment.', err))
}

async function deleteAppointment(caseNumber, appointmentNumber, force = false) {
  const url = force
    ? `/api/cases/${caseNumber}/appointments/${appointmentNumber}?force=true`
    : `/api/cases/${caseNumber}/appointments/${appointmentNumber}`

  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      Accept: 'application/json',
    },
  })

  if (response.status === 204) return null

  const body = await response.json().catch(() => ({}))

  if (!response.ok) {
    const err = new Error(body.message || `HTTP ${response.status}`)
    err.requiresForce = body.requiresForce === true
    err.serverMessage = body.message
    throw err
  }

  return body
}
